import { previewDashboardSearchSchema } from '@/config/commonSearch';
import { dashboardRootRoute, toPath } from '@/utils/routes';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_org/project/$projectId/_dashboards/campaign-optimization/',
)({
    beforeLoad: ({ params, search }) => {
        throw redirect({
            to: toPath(dashboardRootRoute, '/campaign-planner'),
            params: { projectId: params.projectId },
            search: { dashboardId: search.dashboardId },
        });
    },
    validateSearch: previewDashboardSearchSchema,
});
